// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const userInfoSelector = createSelector(
    (state): any => state,
    (res: any) => res.userInfo.userInfo || {}
);

export const userAgentTierSelector = createSelector(
    userInfoSelector,
    res => res.tierName || ''
);

export const userSoldToIdSelector = createSelector(
    userInfoSelector,
    res => res.soldToCustomerNbr || ''
);

export const selectedOptionSelector = createSelector(
    (state): any => state,
    (res: any) => res.userInfo.selectedOption || ''
);